import { authActions } from './actions/auth'
import { userActions } from './actions/users'
import { groupActions } from './actions/groups'
import { catalogActions } from './actions/catalog'
import { contentActions } from './actions/content'
import { mediaActions } from './actions/media'
import { trainingActions } from './actions/trainings'
import { boosterActions } from './actions/boosters'
import { orderActions } from './actions/orders'
import { promotionActions } from './actions/promotions'
import { systemActions } from './actions/system'
import { miscActions } from './actions/misc'

const actions = {
  ...authActions,
  ...userActions,
  ...groupActions,
  ...catalogActions,
  ...contentActions,
  ...mediaActions,
  ...trainingActions,
  ...boosterActions,
  ...orderActions,
  ...promotionActions,
  ...systemActions,
  ...miscActions
}

export { actions }
